module.exports = __webpack_public_path__ + "static/media/iso-warning.6ac8e601.svg";